import { injectGlobal } from 'emotion';
import { userAgent, isInIframe } from 'config/system';

// https://hackernoon.com/amp-ios-scrolling-and-position-fixed-redo-the-wrapper-approach-8874f0ee7876

const iOS12iframeHack = () => {
  if (userAgent.isIOSVersionBelow12 && isInIframe) {
    injectGlobal`
			html {
				overflow-y: scroll !important;
				-webkit-overflow-scrolling: touch !important;
			}

			body, #iOS12IframeHackWrapper {
				overflow-y: auto !important;
				-webkit-overflow-scrolling: touch !important;
				position: absolute !important;
				top: 0 !important;
				left: 0 !important;
				right: 0 !important;
				bottom: 0 !important;
			}

			#ios-12-iframe-hack-scroll-pos {
				position: absolute;
				top: 0;
				left: 0;
				width: 0;
				height: 0;
				visibility: hidden;
			}
		`;

    const elem = document.querySelector('#survey');

    if (elem && elem.parentNode) {
      elem.parentNode.removeChild(elem);
    }

    const surveyDiv = document.createElement('div');
    surveyDiv.id = 'survey';

    const iOS12IframeHackWrapper = document.createElement('div');
    iOS12IframeHackWrapper.id = 'iOS12IframeHackWrapper';

    iOS12IframeHackWrapper.appendChild(surveyDiv);
    document.body.appendChild(iOS12IframeHackWrapper);
  }
};

export default iOS12iframeHack;
